(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("handlebars/dist/handlebars.runtime"), require("q"), require("underscore"), require("u2f-api-polyfill"));
	else if(typeof define === 'function' && define.amd)
		define(["handlebars.runtime", "q", "underscore", "u2f-api-polyfill"], factory);
	else if(typeof exports === 'object')
		exports["OktaSignIn"] = factory(require("handlebars/dist/handlebars.runtime"), require("q"), require("underscore"), require("u2f-api-polyfill"));
	else
		root["OktaSignIn"] = factory(root["handlebars"], root["q"], root["underscore"], root["u2f-api-polyfill"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_34__, __WEBPACK_EXTERNAL_MODULE_72__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition